module.exports = __webpack_public_path__ + "static/media/ig3.9a65a526.jpg";